<template>
  <div>
    <v-card class="ma-5">
      <v-card-title>
        Attendance Data
        <v-spacer></v-spacer>
        
        <!-- search-box -->
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        >
        </v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="attendanceRecords"
        :multi-sort="true"
        v-model="selected"
        :search="search"
        @click:row="clickAttendanceRow"
        class="row-pointer"
        disable-pagination
        hide-default-footer
      >
        <!-- overall attendance stats display -->
        <!-- <template v-slot:item.overall_attendance="{ item }">
          <v-chip color="primary" class="px-8" small to="attendance/details">
            <h4>{{ item.overall_attendance }}%</h4>
          </v-chip>
        </template> -->

        <!-- total students stats display -->
        <template v-slot:item.total_students="{ item }">
          <v-chip color="red" small class="px-8" dark>
            <h4>{{ item.total_students }} students</h4>
          </v-chip>
        </template>

        <!-- room no. display -->
        <template v-slot:item.room_no="{ item }">
            <h4>{{ item.room_no || '-' }}</h4>
        </template>
      </v-data-table>
    </v-card>

    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";
import endpoints from "@api/repository";
import TourHelper from "@utils/tour_helper";


export default {
  name: "AttendanceData",

  data() {
    return {
      search: '',
      snackbar: {
        visible: false,
        text: "",
      },
      // singleSelect: false,
      selected: [],
      headers: [
        {
          text: "Classrooms",
          align: "center",
          sortable: true,
          value: "sections"
        },
        {
          text: "Room no.",
          align: "center",
          sortable: true,
          value: "room_no"
        },
        // {
        //   text: "Overall Attendance",
        //   align: "center",
        //   sortable: true,
        //   value: "overall_attendance"
        // },
        {
          text: "Total Students",
          align: "center",
          sortable: true,
          value: "total_students"
        }
      ],
      attendanceRecords: [],
    };
  },

  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },

  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Welcome to Attendance Section!", description: "View Attendance of different students from a classroom in this module", videoLink: "https://youtube.com"});
        // steps.push({id: '2', title: "GRN", description: "Generate a GRN for a particular order", el: '#item-name'});
        TourHelper.startTour(this, "attendance__dashboard", steps);
    },

    // api call to get attendance records for the class
    async getAllAttendanceRecords() {
      var url = endpoints.classroomAttendance
      this.attendanceRecords = await api.call(this.apiEssentials, url);
    },

    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    // redirect to class-specific attendance details page
    clickAttendanceRow(value) {
      this.$router.push({ name: "AttendanceDetail", params: { classroom_id: value.id } });
    },
  },
  
  created() {
    this.getAllAttendanceRecords();
    this.handleTour();
  },
};
</script>


<style scoped>
.data {
  text-align: start;
  vertical-align: middle;
}

.headers {
  text-align: start;
  font-weight: bolder;
  color: #000000;
  vertical-align: middle;
}

.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
